import React from 'react'
import PropTypes from 'prop-types'

import S from './TabNavigation.styled'

const TabNavigation = ({
  as: As = 'div',
  children,
  onEnterPress = () => {},
  isIcon = false,
  isOutline = false,
  isDisabled = false,
  ...rest
}) => {
  const onKeyDown = ({ key }) => {
    if (key === 'Enter') {
      onEnterPress()
    }
  }

  const a11yProps = {
    tabIndex: 0,
  }

  if (isDisabled) {
    a11yProps.tabIndex = -1
    a11yProps['aria-disabled'] = true
  }

  const StyledTab = S.TabNavigation.withComponent(As)

  if (As === 'button') {
    return (
      <StyledTab
        as="button"
        type="button"
        disabled={isDisabled}
        onKeyDown={onKeyDown}
        onMouseDown={(e) => e.preventDefault()}
        {...rest}
      >
        {children}
      </StyledTab>
    )
  }

  return (
    <StyledTab
      {...a11yProps}
      onKeyDown={onKeyDown}
      onMouseDown={(e) => e.preventDefault()}
      isIcon={isIcon}
      isOutline={isOutline}
      {...rest}
    >
      {children}
    </StyledTab>
  )
}

TabNavigation.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node,
  onEnterPress: PropTypes.func,
  isIcon: PropTypes.bool,
  isOutline: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export default TabNavigation
